namespace GeniuzPOS.ReportMasterData {
    export class Report_1505_NColumns {
        static columnsKey = 'ReportMasterData.Report_1505_N';
    }
}
